import React, { useEffect } from "react";
import { ADSENSE_CLIENT, slotFor } from "../config/ads";

const PRESETS = {
  leaderboard: { w: 728, h: 90, label: "728x90" },
  large_mobile: { w: 320, h: 100, label: "320x100" },
  rectangle: { w: 300, h: 250, label: "300x250" },
  half_page: { w: 300, h: 600, label: "300x600" },
  billboard: { w: 970, h: 250, label: "970x250" },
  responsive: { w: "100%", h: 180, label: "Responsive" },
  infeed: { w: "100%", h: 120, label: "In-feed" },
};

const RealAd = ({ size, adSlot, style }) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      /* slot already filled */
    }
  }, []);
  const fluid = size === "responsive" || size === "infeed";
  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block", ...(fluid ? { width: "100%" } : style) }}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={adSlot}
      {...(fluid ? { "data-ad-format": "auto", "data-full-width-responsive": "true" } : {})}
    />
  );
};

export const AdSlot = ({ size = "responsive", slotId = "", className = "" }) => {
  const preset = PRESETS[size] || PRESETS.responsive;
  const adSlot = slotFor(size, slotId);
  const style = {
    width: typeof preset.w === "number" ? `${preset.w}px` : preset.w,
    maxWidth: "100%",
    height: `${preset.h}px`,
  };

  return (
    <div
      data-testid={`ad-slot-${size}${slotId ? "-" + slotId : ""}`}
      className={`relative mx-auto flex w-full items-center justify-center ${className}`}
    >
      {ADSENSE_CLIENT && adSlot ? (
        <RealAd size={size} adSlot={adSlot} style={style} />
      ) : (
        <div
          style={style}
          className="relative flex w-full items-center justify-center overflow-hidden border border-dashed border-border bg-secondary/40"
        >
          <div className="absolute left-2 top-2 overline-eyebrow text-muted-foreground">Advertisement</div>
          <div className="pointer-events-none text-center">
            <div className="font-display text-2xl text-muted-foreground">{preset.label}</div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground/70">
              AdSense · {slotId || size}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdSlot;
